/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ n: NonNullable<unknown> }} Heating_Curve_Copy_DescriptionInputs */



/**
* | output |
* | --- |
* | "Copy the points of the manual heating curve from network {n}" |
*
* @param {Heating_Curve_Copy_DescriptionInputs} inputs
* @param {{ locale?: "fr" | "en" }} options
* @returns {LocalizedString}
*/
export const heating_curve_copy_description = /** @type {((inputs: Heating_Curve_Copy_DescriptionInputs, options?: { locale?: "fr" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Heating_Curve_Copy_DescriptionInputs, { locale?: "fr" | "en" }, {}>} */ ((i, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return /** @type {LocalizedString} */ (`Copy the points of the manual heating curve from network ${i?.n}`)
	return /** @type {LocalizedString} */ (`Copier les points de la loi d'eau manuelle du réseau ${i?.n}`)
});